class MrFooter extends HTMLElement {

	#observer: IntersectionObserver | null = null;

	constructor() {
		super();

		if ( 'IntersectionObserver' in self ) {
			this.#observer = new IntersectionObserver( ( entries ) => {
				for ( const entry of entries ) {
					if ( !( entry.target instanceof HTMLElement ) ) {
						continue;
					}

					if ( entry.isIntersecting ) {
						document.body?.setAttribute( 'data-footer-is-intersecting', '' );
					} else {
						document.body?.removeAttribute( 'data-footer-is-intersecting' );
					}
				}
			}, {
				threshold: 0.25,
			} );
		}
	}

	// Life cycle
	connectedCallback() {
		this.#observer?.observe( this );
	}

	disconnectedCallback() {
		this.#observer?.unobserve( this );
	}
}

customElements.define( 'mr-footer', MrFooter );
